import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationCargoTaxiContractList from "./taxi-corporation-cargo-taxi-contract-list";
import TaxiCorporationCargoTaxiContractListParams from "./taxi-corporation-cargo-taxi-contract-list-params";

const useTaxiCorporationCargoTaxiContractList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<TaxiCorporationCargoTaxiContractList>({ data: [] });

  const load = async (
    params: TaxiCorporationCargoTaxiContractListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiCorporationCargoTaxiContractListing =
        await taxiCorporationService.getCargoTaxiContractList(params, signal);

      setData(taxiCorporationCargoTaxiContractListing);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiCorporationCargoTaxiContractList;
